'use client';

import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import './index.scss';

export default function H5TopBar({ prefixCls, title }: { prefixCls: string; title: string }) {
    const prefixClsItem = `${prefixCls}-H5TopBar-content`;
    const closeHandle = () => {
        EcoDesignEventsBus.emit('global-header-nav-item1-close');
        EcoDesignEventsBus.emit('ef-header-nav-close');
    };
    const goPrevHandle = () => {
        EcoDesignEventsBus.emit('global-header-nav-item1-close');
    };
    return (
        <div className={prefixClsItem}>
            <span className={`${prefixClsItem}-back`} onClick={goPrevHandle}></span>
            <span className={`${prefixClsItem}-title`}>{title}</span>
            <span className={`${prefixClsItem}-close`} onClick={closeHandle}></span>
        </div>
    );
}
